import { create } from 'zustand';
import { persist, createJSONStorage, devtools } from 'zustand/middleware';
import { UserPreference } from 'src/types/user';

interface UIState {
  isFilterOpen: boolean;
  toggleFilter: () => void;
  openFilter: () => void;
  closeFilter: () => void;

  // User Preference States
  userPreference: UserPreference | null;
  setUserPreference: (userPreference: UserPreference) => void;

  // Filters Rerender mechanism state, used to force rerender of filters
  openFilterKey: string | null;
  setOpenFilterKey: (key: string | null) => void;
  rerenderFilterKey: string;
  setRerenderFilterKey: (key: string) => void;

  // filters persistant copies for website.
  webAccountFiltersCopy: Record<string, any>;
  setWebAccountFiltersCopy: (filters: Record<string, any>) => void;
  webContactFiltersCopy: Record<string, any>;
  setWebContactFiltersCopy: (filters: Record<string, any>) => void;
  // filters persistant copies for TAL.
  talFiltersCopy: Record<string, any>;
  setTalFiltersCopy: (filters: Record<string, any>) => void;
  tclFiltersCopy: Record<string, any>;
  setTclFiltersCopy: (filters: Record<string, any>) => void;
}

const useZustandStore = create<UIState>()(
  devtools(
    persist(
      (set) => ({
        isFilterOpen: true,
        toggleFilter: () => set((state) => ({ isFilterOpen: !state.isFilterOpen })),
        openFilter: () => set({ isFilterOpen: true }),
        closeFilter: () => set({ isFilterOpen: false }),
        userPreference: null,
        setUserPreference: (preference: UserPreference) => set({ userPreference: preference }),
        openFilterKey: null,
        setOpenFilterKey: (key: string | null) => set({ openFilterKey: key }),
        rerenderFilterKey: '',
        setRerenderFilterKey: (key: string) => set({ rerenderFilterKey: key }),
        webAccountFiltersCopy: {},
        setWebAccountFiltersCopy: (filters: Record<string, any>) =>
          set({ webAccountFiltersCopy: filters }),
        webContactFiltersCopy: {},
        setWebContactFiltersCopy: (filters: Record<string, any>) =>
          set({ webContactFiltersCopy: filters }),
        talFiltersCopy: {},
        setTalFiltersCopy: (filters: Record<string, any>) => set({ talFiltersCopy: filters }),
        tclFiltersCopy: {},
        setTclFiltersCopy: (filters: Record<string, any>) => set({ tclFiltersCopy: filters }),
      }),
      {
        name: 'zustand-ui-storage',
        storage: createJSONStorage(() => localStorage),
      },
    ),
    { name: 'Zustand Store', enabled: process.env.NODE_ENV === 'development' },
  ),
);

export default useZustandStore;
